import { render, staticRenderFns } from "./Elevator.vue?vue&type=template&id=20a0c7c6"
import script from "./Elevator.vue?vue&type=script&lang=js"
export * from "./Elevator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports